import { useGet } from './useHttpHooks';
import { Tag } from '../types';

type TagByNameQuery = { tagName: string };

const useGetTagByName = (request: TagByNameQuery) =>
    useGet<Tag>(`/api/tags/${encodeURIComponent(request.tagName)}`, {
        errorMessage: 'GET /api/tags/{tagName} failed'
    });

export default useGetTagByName;
